module.exports = __webpack_public_path__ + "static/media/noise-artboard.fc62245c.svg";